<script>
  import { createEventDispatcher } from 'svelte';
  import { location } from 'svelte-spa-router';
  import { datasource } from '../lib/stores.js';
  export let user = null;
  export let admin = false;
  const dispatch = createEventDispatcher();
  // Flip the Firestore data source and reload so all ecard/view data refetches.
  function toggleSource() {
    datasource.set($datasource === 'staging' ? 'prod' : 'staging');
    location.reload();
  }
  $: label = (user && user.primaryEmailAddress && user.primaryEmailAddress.emailAddress)
    || (user && user.firstName) || '';
  // Orders detail/label routes still belong to the Orders tab.
  $: onEcards = $location.startsWith('/ecards');
  $: onAnalytics = $location.startsWith('/analytics');
  $: onVisits = $location.startsWith('/visits');
  $: onSiteVisits = $location.startsWith('/site-visits');
  $: onAnnotate = $location.startsWith('/annotate') || (!admin && $location === '/');
</script>

<header>
  <div class="brand">
    <h1>Card Hero</h1>
    <nav>
      {#if admin}
        <a href="#/" class:active={!onEcards && !onAnalytics && !onVisits && !onSiteVisits && !onAnnotate}>Orders</a>
        <a href="#/ecards" class:active={onEcards}>Ecards</a>
        <a href="#/analytics" class:active={onAnalytics}>Analytics</a>
        <a href="#/visits" class:active={onVisits}>Ad visits</a>
        <a href="#/site-visits" class:active={onSiteVisits}>Site visits</a>
      {/if}
      <a href="#/annotate" class:active={onAnnotate}>Annotate</a>
    </nav>
  </div>
  <div class="right">
    {#if admin}
      <button class="src" class:staging={$datasource === 'staging'} on:click={toggleSource}
              title="Toggle the ecard data source (Firestore). Orders pages stay on prod Shopify.">
        {$datasource === 'staging' ? '🟠 STAGING data' : '🟢 prod data'}
      </button>
    {/if}
    {#if label}<span class="who">{label}</span>{/if}
    <button on:click={() => dispatch('signout')}>Sign out</button>
  </div>
</header>

<style>
  header { display: flex; justify-content: space-between; align-items: center; padding: .7rem 1.25rem; background: #111; color: #fff; }
  .brand { display: flex; align-items: baseline; gap: 1.5rem; }
  h1 { font-size: 1.05rem; margin: 0; font-weight: 600; }
  nav { display: flex; gap: .25rem; }
  nav a { color: #bbb; text-decoration: none; font-size: .9rem; padding: .3rem .7rem; border-radius: 6px; }
  nav a:hover { color: #fff; }
  nav a.active { color: #fff; background: rgba(255,255,255,.15); font-weight: 600; }
  .right { display: flex; gap: 1rem; align-items: center; }
  .who { font-size: .85rem; opacity: .8; }
  button { cursor: pointer; background: #fff; color: #111; border: 0; padding: .35rem .75rem; border-radius: 6px; font-size: .85rem; }
  .src { background: #1f3d1f; color: #d6f5d6; font-weight: 600; font-size: .8rem; }
  .src.staging { background: #7a3e00; color: #ffd9a8; }
</style>
